import script from "./AddressForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressForm.vue?vue&type=script&setup=true&lang=ts"

import "./AddressForm.vue?vue&type=style&index=0&id=5aebf381&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aebf381"]])

export default __exports__